import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  importedAsShippedHeader: {
    defaultMessage: 'No Shipment Record',
    description: 'Text saying that we have no shipment record because the shipment was imported as shipped',
    id: 'E3n6Ra',
  },
  importedAsShippedContent: {
    defaultMessage: 'This shipment was imported as Shipped',
    description: 'Text saying that we have no shipment record because the shipment was imported as shipped',
    id: 'fyI21K',
  },
  importedAsShippedSectionAriaLabel: {
    defaultMessage: 'Imported as Shipped section',
    description: 'Label for a section indicating that the shipment was imported as shipped',
    id: '6nPb+3',
  },
});
